// generated by genversion
export var version = '3.2.8';
//# sourceMappingURL=version.js.map